import { Type } from "@angular/core";
import { ActionReducer, ActionReducerMap, MetaReducer, RuntimeChecks } from "@ngrx/store";
import { StoreDevtoolsConfig } from "@ngrx/store-devtools";
import { localStorageSync, LocalStorageConfig } from 'ngrx-store-localstorage';

import { SystemEffects } from "./effects/system.effects";
import { systemReducers } from "./reducers/system.reducers";
import { AppState } from "./states/app.state";
import { authReducers } from "./reducers/auth.reducers";
import { AuthEffects } from "./effects/auth.effects";
import { environment } from "src/environments/environment";


export const reducers: ActionReducerMap<AppState> = {
	auth: authReducers,
	system: systemReducers
};

export const effects: Array<Type<unknown>> = [AuthEffects, SystemEffects];

export const runtimeChecks: RuntimeChecks = {
	strictActionImmutability: true,
	strictActionSerializability: true,
	strictActionWithinNgZone: true,
	strictStateImmutability: true,
	strictStateSerializability: true,
	strictActionTypeUniqueness: true
};

export const devtoolsConfig: StoreDevtoolsConfig = {
  maxAge: 25,
  logOnly: false
};

function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync(localStorageConfig)(reducer);
}

const localStorageConfig: LocalStorageConfig = {
  keys: ['auth', { system: ['theme'] }],
  rehydrate: true,
  storageKeySerializer: (key: string) => `${environment.localStorageKeyPrefix}_${key}`,
};

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];
